import React, { useState, useEffect } from 'react';
import './Countdown.css';

const CountdownManager = () => {
  const [fromTime, setFromTime] = useState('');
  const [toTime, setToTime] = useState('');
  const [countdowns, setCountdowns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch countdowns when component mounts
  useEffect(() => {
    fetchCountdowns();
  }, []);

  // GET request to fetch countdowns
  const fetchCountdowns = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://admin.riymay.com/api/v1/admin/count-down',
        { 
          method: "GET",
          headers: {
          'Content-Type': 'application/json', // Specify the content type
          'Authorization': `Bearer ${localStorage.getItem("admintoken")}`, // Add the Bearer token
        },
    });
      if (!response.ok) throw new Error('Failed to fetch countdowns');
      const data = await response.json();
      setCountdowns(data);
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to fetch countdowns');
    } finally {
      setLoading(false);
    }
  };

  // POST request to set a new countdown
  const handleSetCountdown = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = { fromTime, toTime };
      const response = await fetch('https://admin.riymay.com/api/v1/admin/count-down', {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json', // Specify the content type
        'Authorization': `Bearer ${localStorage.getItem("admintoken")}`, // Add the Bearer token
        },
        body: JSON.stringify(payload),
      });
      if (!response.ok) throw new Error('Failed to set countdown');
      setFromTime('');
      setToTime('');
      fetchCountdowns(); // Refresh the list
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to set countdown');
    } finally {
      setLoading(false);
    }
  };

  // DELETE request to remove a countdown
  const handleDeleteCountdown = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(`https://admin.riymay.com/api/v1/admin/count-down/${id}`,  { 
        method: "DELETE",
        headers: {
        'Content-Type': 'application/json', // Specify the content type
        'Authorization': `Bearer ${localStorage.getItem("admintoken")}`, // Add the Bearer token
      },
    });
      if (!response.ok) throw new Error('Failed to delete countdown');
      fetchCountdowns(); // Refresh the list
      setError(null);
    } catch (err) {
      setError(err.message || 'Failed to delete countdown');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="countdown-manager">
      <h1>Countdown Manager</h1>

      {/* Form to set a new countdown */}
      <form onSubmit={handleSetCountdown} className="countdown-form">
        <div className="form-group">
          <label>From Time:</label>
          <input
            type="date"
            value={fromTime}
            onChange={(e) => setFromTime(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <label>To Time:</label>
          <input
            type="date"
            value={toTime}
            onChange={(e) => setToTime(e.target.value)}
            required
          />
        </div>
        <button type="submit" disabled={loading}>
          {loading ? 'Setting...' : 'Set Countdown'}
        </button>
      </form>

      {/* Display existing countdowns */}
      <div className="countdown-list">
        <h2>Existing Countdowns</h2>
        {loading && <p>Loading...</p>}
        {/* {error && <p className="error">{error}</p>} */}
        {!loading && countdowns.length === 0 && <p>No countdowns found.</p>}
        {countdowns.map((countdown) => (
          <div key={countdown._id} className="countdown-item">
            <p>
              From: {new Date(countdown.fromTime).toLocaleDateString()} - To:{' '}
              {new Date(countdown.toTime).toLocaleDateString()}
            </p>
            <button
              onClick={() => handleDeleteCountdown(countdown._id)}
              disabled={loading}
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CountdownManager;